// extracted by mini-css-extract-plugin
export var container = "_m6-0";
export var dotAnimation = "_m6-2";
export var dotsLoading = "_m6-1";